import { forwardRef, type Ref, type SVGProps } from "react";
const IconLotSizeFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="m30.9 26.4-5.6-8a1 1 0 0 0-.8-.4H13v-2a4.7 4.7 0 0 0 4-4.5 4.3 4.3 0 0 0-1.6-3.3 4 4 0 1 0-6.8 0A4.3 4.3 0 0 0 7 11.5a4.7 4.7 0 0 0 4 4.4V18H7.5a1 1 0 0 0-.8.4l-5.6 8a1 1 0 0 0 .8 1.6h28.2a1 1 0 0 0 .8-1.6m-27-.4L8 20h3v2a1 1 0 0 0 2 0v-2h11l4.2 6z" />
  </svg>
);
const ForwardRef = forwardRef(IconLotSizeFilledSVG);
ForwardRef.displayName = "IconLotSizeFilled";
export { ForwardRef as IconLotSizeFilled };
